module.exports = __webpack_public_path__ + "img/rank3_2.3c352163.png";